import React from "react";
import { useTranslation } from "react-i18next";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import InfoIcon from "@mui/icons-material/Info";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  cardHeader: {
    variant: "h1",
    fontSize: 20,
    fontWeight: 600,
  },
  labelTypo: {
    fontSize: 14,
    marginTop: 0,
    marginBottom: 2,
  },
  customIcon: {
    color: "#1c355e",
    height: 200,
    width: 200,
    opacity: 0.1,
  },
  cardSpace: {
    [theme.breakpoints.up("sm")]: {
      margin: 24,
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: 24,
    },
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "left",
    height: 280,
    width: 320,
  },
  unauthorizedText: {
    marginTop: -180,
    transform: "translate(0%, 0%)",
    overflow: "hidden",
    fontSize: "0.875rem",
    textAlign: "center",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      opacity: 0,
    },
  },
}));

let UnauthorizedCard = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div>
      <Grid item className={classes.cardSpace}>
        <Paper className={classes.paper} elevation={2}>
          <Grid container direction="column">
            <Grid item>
              <Typography className={classes.cardHeader}>
                {t("securepay.unauthorized")}
              </Typography>
            </Grid>
            <Grid item style={{ marginTop: 0, textAlign: "center" }}>
              <InfoIcon className={classes.customIcon} />
              <div className={classes.unauthorizedText}>
                <p className={classes.labelTypo}>
                  {t("securepay.securepayLinkdesc.0")}
                  <br />
                  {t("securepay.securepayLinkdesc.1")}
                </p>
              </div>

              <Button
                href="tel:+1-800-634-3077"
                size="medium"
                variant="contained"
                color="secondary"
                style={{
                  width: 150,
                  height: 36,
                  color: "white",
                  background: "#1c355e",
                  fontSize: 14,
                  fontWeight: 500,
                  marginTop: 10,
                }}
              >
                (800) 634-3077
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </div>
  );
};

export default UnauthorizedCard;
